export default "__VITE_ASSET__80356d1c__"